import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import api from "../lib/api";
import useSEO from "../hooks/useSEO";

export default function Testimonials() {
  useSEO({ title: "Témoignages", description: "Ils ont rejoint DemkaBiz : témoignages de nouveaux arrivants, entrepreneurs et professionnels francophones au Canada." });
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="testimonials-page">
      <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Témoignages</p>
      <h1 className="font-display font-bold text-4xl sm:text-5xl text-foreground tracking-tight">Ils nous font confiance</h1>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {items.map((t) => (
          <div key={t.id} className="card-surface p-7" data-testid={`testimonial-${t.id}`}>
            <Quote className="w-7 h-7 text-primary/30 mb-3" />
            <div className="flex gap-0.5 mb-2">
              {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
            </div>
            <p className="text-foreground leading-relaxed">{t.content}</p>
            <div className="flex items-center gap-3 mt-6 pt-5 border-t border-emerald-900/10">
              {t.photo_url && <img src={t.photo_url} alt={t.author} className="w-12 h-12 rounded-full object-cover" />}
              <div>
                <div className="font-display font-semibold">{t.author}</div>
                <div className="text-xs text-muted-foreground">{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
